import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/es5/locale/es'
Vue.use(Vuetify)

export default new Vuetify({
    icons: {
      iconfont: 'fa',
    },
    lang: {
      locales: { es },
      current: 'es',
    },
    theme: {
      themes: {
        primary: {
          primary:'#4DB6AC',
          secondary:'#2d3239',
          white: '#FFFFFF',
          danger: '#C62828',
        },
      },
    }
})